// Store ID
export const STORE_NAME = 'media-manager/media-source'; // Media statuses.

export const STATE_NOT_READY = 'is-not-ready';
export const STATE_PLAYING = 'is-playing';
export const STATE_ERROR = 'is-error';
export const STATE_PAUSED = 'is-paused';
export const MEDIA_NOT_DEFINED = 'media-not-defined-yet';
export const DEFAULT_STATE = {
  sources: {},
  default: null
};
//# sourceMappingURL=constants.js.map